module.exports = __webpack_public_path__ + "static/media/pins.4c253e15.svg";